import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import '../styles/disenocalculadorasbase.css';

export default function CalculadoraRenovacion() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <div className="calculadora-container simple-layout">
      <h1>Renovacion</h1>
      <p>Nombre:</p>
      <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
      <p>Edad:</p>
      <input type="number" value={edad} onChange={(e) => setEdad(e.target.value)} />
      <p>Ingreso al fondo (mensualmente)</p>
      <input type="number" value={ingreso} onChange={(e) => setIngreso(e.target.value)} />
      <p>Tiempo</p>
      <select value={tiempo} onChange={(e) => setTiempo(e.target.value)}>
        {[...Array(20)].map((_, i) => (
          <option key={i + 1} value={i + 1}>{i + 1}</option>
        ))}
      </select>
      <p></p>
      <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>
    </div>
  )
}